module.exports = __webpack_public_path__ + "static/media/van_ticket.b86da7d9.png";